import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import FormContainer from '../Components/FormContainer';

const ResetPasswordScreen = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const token = params.get('token') || '';
  const email = params.get('email') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setMsg(''); setErr('');
    if (password.length < 6) return setErr('Password must be at least 6 characters long');
    if (password !== confirm) return setErr('Passwords do not match');
    setBusy(true);
    try {
      const res = await fetch('/api/users/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, newPassword: password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Reset failed');
      setMsg('Password has been reset. You can now sign in.');
      setTimeout(() => navigate('/login'), 900);
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <FormContainer>
      <h1>Reset Password</h1>
      {msg && <Alert variant="success">{msg}</Alert>}
      {err && <Alert variant="danger">{err}</Alert>}
      <Form onSubmit={submitHandler}>
        <Form.Group className="my-3" controlId="password">
          <Form.Label>New Password</Form.Label>
          <Form.Control type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required />
        </Form.Group>
        <Form.Group className="my-3" controlId="confirm">
          <Form.Label>Confirm New Password</Form.Label>
          <Form.Control type="password" value={confirm} onChange={(e)=>setConfirm(e.target.value)} required />
        </Form.Group>
        <Button type="submit" variant="primary" disabled={busy}>Reset Password</Button>
      </Form>
    </FormContainer>
  );
};

export default ResetPasswordScreen;
